import { useState } from "react";
import { Col, message, Row } from "antd";
import { useHistory, useParams } from "react-router-dom";

import "./companyUsers.less";
import { getColumns } from "./config";
import Button from "@components/Button";
import Table from "@components/Table";
import {
  ErrorServices,
  useFetchCompanyUsersQuery,
  useUpdateCompanyUserStatusMutation,
} from "@services";
import { useTypedSelector } from "@hooks";
import { paths, permissions } from "@router";
import { checkPermission } from "@utils";

const CompanyUsers = () => {
  const history = useHistory();
  const params: { company_id: string } = useParams();
  const paramsCompanyId = params.company_id;
  const [page, setPage] = useState(1);
  const { user, permissions: per } = useTypedSelector(state => state.auth);
  const { id: company_id } = user?.company || { id: paramsCompanyId };

  const [updateCompanyUserStatus] = useUpdateCompanyUserStatusMutation();
  const [pageSize, setPageSize] = useState(10); // ✅ Add pageSize state

  const { data, isLoading } = useFetchCompanyUsersQuery({
    company_id,
    page,
    page_size: pageSize,
  });
  const { data: users, pagination } = data || {};

  const updateCompanyUser = (id: number) =>
    history.push(`/company-users/edit/${id}/company/${company_id}`);

  const updateStatus = async (
    user_id: number,
    name: string,
    is_active: boolean
  ) => {
    try {
      await updateCompanyUserStatus({
        company_id,
        user_id,
        is_active,
      }).unwrap();
      message.success(`${name} is ${is_active ? "active" : "inactive"}`);
    } catch (err: any) {
      ErrorServices(err);
    }
  };

  const columns = getColumns({
    updateStatus,
    id: user?.id!,
    updateCompanyUser,
  });

  return (
    <div className="sub-admins">
      <div className="bg-white p-4 sm:p-5">
        <div className="jobCreationBar  sticky top-0 z-10 bg-themeCore px-14 py-6 rounded-lg flex justify-between items-center mb-7">
          <div className="title text-white font-[500] text-3xl uppercase">
            Company-Users
          </div>
          {(per.includes("CREATE_COMPANY_USER") || per.includes("all")) && (
            <Button
              variant="buttonWhite"
              onClick={() =>
                history.push(
                  `${paths.client.users.company_users.company_user}/create/${company_id}`
                )
              }
            >
              Create Company User
            </Button>
          )}
        </div>

        <Table
          data={users}
          isLoading={isLoading}
          columns={columns}
          pagination={true}
          count={pagination?.count}
          onChangePage={setPage}
          onPageSizeChange={setPageSize}
          page={page}
        />
      </div>
    </div>
  );
};

export default CompanyUsers;
